<template>
  <ckeditor
    v-model="texte"
    :config="editorConfig"
    @ready="$emit('ready', $event)">
  </ckeditor>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import CKEDITOR_CONF from '@/configuration/general/ckeditorConf';
import { createNamespacedHelpers } from 'vuex';

const User = createNamespacedHelpers('user');

export default {
  name: 'qd-text-editor',
  props: {
    value: {
      type: String,
      default: null,
    },
    height: {
      type: Number,
      default: 200,
    },
    addToolbarItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...User.mapGetters({
      isSupport: 'isSupport',
    }),
    texte: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    editorConfig() {
      const config = cloneDeep(CKEDITOR_CONF);
      config.height = this.height;
      if (this.addToolbarItems.length > 0) {
        config.toolbar.push(this.addToolbarItems);
      }
      if (this.isSupport) {
        config.toolbar.push(['Source']);
      }
      return config;
    },
  },
};
</script>

<style>

</style>
